import React from "react";
import style from "./index.module.css";

function ImageSkeleton() {
  return <div className={style.image}></div>;
}

export default ImageSkeleton;
